import { render } from "./AppSignUp.vue?vue&type=template&id=309aab8c"
import script from "./AppSignUp.vue?vue&type=script&lang=js"
export * from "./AppSignUp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Domain\\repos\\quizup.top\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__